import AddToBasketOverlay from "../typescript/modules/add-to-basket-overlay";
import DeliveryChecker from "../typescript/modules/delivery-checker";
import DeliveryEstimate from "../typescript/modules/delivery-estimate";
import Ecommerce from "../typescript/modules/ecommerce";
import FormElementSync from "../typescript/modules/form-element-sync";
import Helpers from "../typescript/modules/helpers";
import ImageZoom from "../typescript/modules/image-zoom";
import ProductGridLoad from "../typescript/modules/product-grid-load";
import ProductPage from "../typescript/modules/product-page";
import RevealContent from "../typescript/modules/reveal-content";
import SlideToggle from "../typescript/modules/slide-toggle";
import VariantSelector from "../typescript/modules/variants";
import YotpoLoader from "../typescript/modules/yotpo-loader";
import { VariantSelectorElement } from "../ui/components/product-variant-selector";

function setupImageZooms() {
	const imagesToZoomOnLoad = document.querySelectorAll('.js-image-zoom');
	for (let i = 0; i < imagesToZoomOnLoad.length; i++) {
		new ImageZoom(imagesToZoomOnLoad[i] as HTMLElement);
	}
	document.addEventListener('click', (e) => {
		const target = e.target as HTMLElement;
		if (!target.closest('.js-image-zoom')) {
			const resetImageZoomEvent = Helpers.createCustomEventForDispatch('resetImageZoom');
			document.dispatchEvent(resetImageZoomEvent);
		}
	});
}

setupImageZooms();

(<any>window).ImageZoom = ImageZoom;

(<any>window).deliveryEstimate = new DeliveryEstimate();

(<any>window).ProductPage = new ProductPage();

(<any>window).FormElementSync = FormElementSync;

(<any>window).AddToBasketOverlay = AddToBasketOverlay;

(<any>window).Ecommerce = Ecommerce;
const ecommerceElements = document.querySelectorAll('button.addToBasket');
for (let i = 0; i < ecommerceElements.length; i++) {
	new Ecommerce(ecommerceElements[i] as HTMLElement);
}

(<any>window).DeliveryChecker = DeliveryChecker;
new DeliveryChecker();

(<any>window).RevealContent = RevealContent;
new RevealContent();

(<any>window).ProductGridLoad = ProductGridLoad;
const productGrids = document.querySelectorAll('.js-product-grid-load');
for (let i = 0; i < productGrids.length; i++) {
	new ProductGridLoad(productGrids[i] as HTMLElement);
}

(<any>window).slideToggle = new SlideToggle();

const variantSelectorElements = document.querySelectorAll('product-variant-selector');
for (let i = 0; i < variantSelectorElements.length; i++) {
	new VariantSelector(variantSelectorElements[i] as VariantSelectorElement);
}

new YotpoLoader();
